
import React, { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";

const BarChartAnalyticalReport3 = ({ data }) => {
  const [Data, setData] = useState({
    labels: ["18-20", "21-30", "31-40", "41-50", "51-60", "61-70", "71-80", "81-90"],
    datasets: [
      {
        label: "Transaction Count",
        data: [0, 0, 0, 0, 0, 0, 0, 0],
        fill: true,
        tension: 0.4,
        backgroundColor: "#2d8edb",
      },
      {
        label: "Customer Count",
        data: [120000, 12300, 4400, 10000, 20000, 29999, 2122, 22222], 
        fill: true,
        tension: 0.4,
        backgroundColor: "red",
      },
    ],
  });

  useEffect(() => {

    setData({

      ...Data,
  
      datasets: Data?.datasets.map((obj, ind) => {
  
          if (ind===0) return { ...obj, data:data };
  
          return obj;
  
      }),
  
  });
  }, [data]);

  const Options = {
    indexAxis: "x",
    element: {
      legend: {
        position: "top",
      },
    },
    responsive: true,
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="analyticalReportChartAnalysisTwo__barChartReport">
      <Bar data={Data} options={Options} />
    </div>
  );
};

export default BarChartAnalyticalReport3;
